export default {
  homeMenu: {
    name: 'My Consent',
    desc: 'Consent agreement status'
  }
}
